module.exports = __webpack_public_path__ + "static/media/27-4.4fe03a40.mp3";